<template>
  <v-dialog persistent v-model="showDialog" max-width="400">
    <v-card>
      <v-card-title style="font-size: 16px"
        ><p>{{ message }}</p></v-card-title
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          style="font-size: 18px"
          class="green--text"
          @click="confirm(true)"
          >Yes</v-btn
        >
        <v-btn
          text
          style="font-size: 18px"
          class="red--text"
          @click="confirm(false)"
          >No</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: String,
    show: Boolean,
  },
  data() {
    return {
      showDialog: this.show,
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
    },
  },
  methods: {
    confirm(answer) {
      this.showDialog = false;
      this.$emit("confirm", answer);
    },
  },
};
</script>
